'use client';

import { c as _c } from "react/compiler-runtime";
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons';
import { useCachedCourseUnitTimeProgressSWR } from '~/app/actions/progress';
import OverviewStatusChip from '~/components/progress/OverviewStatusChip';
import { SupportedLocales } from '~/types';
export default function UnitOverviewDoneTime(t0) {
  const $ = _c(7);
  const {
    courseId,
    unitId,
    locale,
    totalMinutes
  } = t0;
  let t1;
  if ($[0] !== courseId || $[1] !== locale) {
    t1 = {
      courseId,
      locale
    };
    $[0] = courseId;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data
  } = useCachedCourseUnitTimeProgressSWR(t1);
  const completedMinutes = data?.unitCompletedMinutes?.[Number(unitId)] ?? 0;
  const t2 = `${completedMinutes} / ${totalMinutes} min`;
  let t3;
  if ($[3] !== completedMinutes || $[4] !== t2 || $[5] !== totalMinutes) {
    t3 = <OverviewStatusChip icon={faPlayCircle} kind="time" completed={completedMinutes} total={totalMinutes} showWhenZero={true} label={t2} />;
    $[3] = completedMinutes;
    $[4] = t2;
    $[5] = totalMinutes;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}